



































































































import QuotesTermTemplateList from '@/components/quotes/templates/terms/QuoteTermTemplateList.vue';
import QuotesTermTemplateFormDialog from '@/components/quotes/templates/terms/QuoteTermTemplateFormDialog.vue';
import ALPage from '@/components/core/Page/ALPage.vue';

import {
  QuoteTermTemplate,
  IQuoteTermTemplate,
  QuoteOrganization,
  IQuoteOrganization
} from '@/models';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteTemplateNoteTooltipIcon from '@/components/quotes/templates/common/QuoteTemplateNoteTooltipIcon.vue';

export default Vue.extend({
  components: {
    QuotesTermTemplateList,
    QuotesTermTemplateFormDialog,
    ALPage,
    ErrorAlert,
    QuoteTemplateNoteTooltipIcon
  },

  data: () => ({
    search: '',
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    organization: QuoteOrganization.Jamesway.value,
    localTermTemplates: [] as IQuoteTermTemplate[]
  }),

  computed: {
    ...mapGetters({
      getQuoteTermTemplatesByOrganization:
        'quoteTemplate/getQuoteTermTemplatesByOrganization'
    }),

    termTemplates(): IQuoteTermTemplate[] {
      return this.getQuoteTermTemplatesByOrganization(this.organization);
    },

    organizationsList(): IQuoteOrganization[] {
      return QuoteOrganization.getOrganizationList();
    }
  },

  watch: {
    termTemplates: {
      handler(termTemplates: IQuoteTermTemplate[]) {
        this.localTermTemplates = termTemplates;
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    this.loading = true;
    this.fetchQuoteTermTemplates()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      setQuoteTermTemplatesOrder: 'quoteTemplate/setQuoteTermTemplatesOrder',
      fetchQuoteTermTemplates: 'quoteTemplate/fetchQuoteTermTemplates',
      deleteQuoteTermTemplate: 'quoteTemplate/deleteQuoteTermTemplate'
    }),

    openTerm(item?: IQuoteTermTemplate, createForm = true) {
      const dialog = (this as any).$refs.quoteTermFormDialog;
      dialog.open(item ?? new QuoteTermTemplate(), createForm);
    },

    addTerm() {
      const termTemplate = new QuoteTermTemplate({
        title: '',
        description: '',
        organization: this.organization,
        order: this.termTemplates.length + 1
      });
      this.openTerm(termTemplate, true);
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async deleteQuoteTermItem(item: IQuoteTermTemplate) {
      const confirm = (this as any).$refs.confirm;
      const title = item.title;

      if (
        await confirm.open(
          'Delete Quote Term',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <div><strong class="text--primary" style="word-break: normal">${title}</strong>?</div> <br /> This action cannot be undone.</span>`
        )
      ) {
        this.clearAllErrors();
        await this.deleteQuoteTermTemplate(item.id).catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        });
      }
    },

    updateTermTemplateOrder(difference: IQuoteTermTemplate[]) {
      this.clearAllErrors();
      this.loading = true;

      this.setQuoteTermTemplatesOrder(difference)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
          /** refresh from state if moving any term order fails */
          this.localTermTemplates = this.termTemplates;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
